export const Z_INDEX = {
  sidebar: 50,
  nav: 150, // 지도(100)보다 zIndex커야 함
  secondaryNav: 130,
  mapSide: 120, // 지도(100)보다 zIndex커야 함
  mapSidePopup: 125,
  mapFloating: 115, // mapSide보다 작아야함
  drawer: 200,
  mobileNav: 300, // drawer보다 zIndex커야 함
  landingSearchBar: 99,
  checkboxContainer: 9_999,
  userDropDown: 99_999,
  fixedPane: 100_000,
  paymentModal: 999_999, // 토스 결제창 zIndex(9,999,999)보다 작아야함
  globalFloating: 100_000_000,
  modal: 100_000_010,
  snackbar: 100_000_011,
};
